import Vue from 'vue';

import VueAmelipro from 'amelipro-ds/src/index';

Vue.use(VueAmelipro);
